var map = {
	"./black/repository-black-da.json": 58,
	"./black/repository-black-de.json": 59,
	"./black/repository-black-ee.json": 60,
	"./black/repository-black-en.json": 61,
	"./black/repository-black-no.json": 62,
	"./black/repository-black-se.json": 63,
	"./black/template-setups-black.json": 29,
	"./grey/repository-grey-da.json": 64,
	"./grey/repository-grey-de.json": 65,
	"./grey/repository-grey-ee.json": 66,
	"./grey/repository-grey-en.json": 22,
	"./grey/repository-grey-no.json": 67,
	"./grey/repository-grey-se.json": 68,
	"./grey/template-setups-grey.json": 28,
	"./hd/repository-hd-da.json": 69,
	"./hd/repository-hd-de.json": 70,
	"./hd/repository-hd-ee.json": 71,
	"./hd/repository-hd-en.json": 72,
	"./hd/repository-hd-no.json": 73,
	"./hd/repository-hd-se.json": 74,
	"./hd/template-setups-hd.json": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;